import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { MessageSquare, AlertTriangle } from 'react-feather';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { AppState } from '../store';
import { loadQueue } from '../store/api';
import { selectQueueById } from '../store/queues-slice';
import { selectPositionById } from '../store/positions-slice';
import Header from '../components/header';
import Card from '../components/card';
import CardLayout from '../components/card-layout';

export default function Position() {
  const dispatch = useDispatch();
  const params = useParams<{ organization: string; queue: string; position: string }>();
  const queue = useSelector((state: AppState) =>
    selectQueueById(state.queues, params.queue),
  );
  const position = useSelector((state: AppState) =>
    selectPositionById(state.positions, params.position),
  );
  const phoneNumber =
    parsePhoneNumberFromString(
      position?.notification?.settings?.to ?? '',
    )?.formatNational() ?? '';

  useEffect(() => {
    dispatch(loadQueue(params));
  }, [dispatch, params]);

  return (
    <Container>
      <Header>{queue?.title ?? ''}</Header>
      <Card fillAvailable={true}>
        <QueueNumber>
          You have position
          {position && <strong>{position.label}</strong>}
        </QueueNumber>
      </Card>
      <Card>
        <CardLayout icon={<MessageSquare size={32} />}>
          <p>
            We will send an SMS{' '}
            {phoneNumber && (
              <>
                to <strong>{phoneNumber}</strong>
              </>
            )}{' '}
            when it is your turn to enter the shop.
          </p>
        </CardLayout>
      </Card>
      <Card danger={true}>
        <CardLayout icon={<AlertTriangle size={32} />}>
          <p>
            Please keep a safe distance from other customers while you wait. Thank you.
          </p>
        </CardLayout>
      </Card>
    </Container>
  );
}

const QueueNumber = styled('div')`
  margin: auto;
  align-self: flex-start;
  padding: 16px 0;

  strong {
    display: block;
    font-size: 88px;
  }
`;

const Container = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;

  @media (orientation: landscape) {
    width: 100%;
    position: static;
    flex-direction: row;
    flex-wrap: wrap;
    bottom: auto;
    padding-bottom: 24px;
  }
`;
